import { UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';
import styles from './AreaPartTitle.css';
import { IAreaPartTitleProps } from './types';
import { AreaPartDeleteButton } from '../../../../buttons/AreaPartDeleteButton/AreaPartDeleteButton';

export const AreaPartTitle: React.FC<IAreaPartTitleProps> = props => {
  const { title, onDeleteButtonClick, active } = props;

  const handleDelete = React.useCallback(() => {
    if (!active) {
      return;
    }

    onDeleteButtonClick();
  }, [active, onDeleteButtonClick]);

  return (
    <div className={styles['heading-container']}>
      <UIHeading4>{title}</UIHeading4>
      <div className={styles['delete-button-container']}>
        <AreaPartDeleteButton onClick={handleDelete} active={active} />
      </div>
    </div>
  );
};
